import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Alert,
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import CustomDateModal from '../../CustomModal/CustomDateModal';
import { useSelector } from 'react-redux';

const Voucher = () => {
  //----------- REDUCE TOOLKIT -------
  const vendorState = useSelector((state) => state.vendorState);
  const branchState = useSelector((state) => state.branchState);
  const { user } = useSelector((state) => state.authState);

  const navigate = useNavigate();
  const [voucherList, setVoucherList] = useState([]);
  const [voucherTypeList, setVoucherTypeList] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [voucherTypeName, setVoucherTypeName] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [showDateModel, setShowDateModel] = useState(false);
  const [allDateSelected, setAllDateSelected] = useState(true);
  const [totalPage, setTotalPage] = useState(); // Current page for pagination

  const onHandleSearchKeyItem = (e) => {
    const value = e.target.value;
    setSearchKey(value);
    getVoucherMasterData(1, 10, value);
  };

  const getVoucherMasterData = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      // let query = ""
      //     ? search = ${ search }& startDate=${ startDate }& endDate=${ endDate }& type=${ voucherTypeName }

      let queryParams = '';
      if (search) queryParams += `&search=${encodeURIComponent(search)}`;
      if (startDate)
        queryParams += `&startDate=${encodeURIComponent(startDate)}`;
      if (endDate) queryParams += `&endDate=${encodeURIComponent(endDate)}`;
      if (voucherTypeName)
        queryParams += `&type=${encodeURIComponent(voucherTypeName)}`;

      const response = await apiService.get(
        `/api/VoucherMaster/allVoucher?${queryParams}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        console.log(response);
        setVoucherList(response.vou_masterData);
        setTotalPage(response.totalPages);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getVoucherTypeList = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/VoucherMaster/allVoucherList`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setVoucherTypeList(response.vou_list_masterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  // const handleSearchChange = (e) => setSearch(e.target.value);
  // const handleStartDateChange = (e) => setStartDate(e.target.value);
  // const handleEndDateChange = (e) => setEndDate(e.target.value);
  // const handleTypeNameChange = (e) => setVoucherTypeName(e.target.value);

  useEffect(() => {
    getVoucherMasterData('');
    getVoucherTypeList();
  }, []);

  const filterData = () => {
    getVoucherMasterData();
  };

  const onHandleAddVoucher = () => {
    navigate('/addvoucher');
  };

  const onHandleEditVoucher = (id) => {
    let findArrayData = voucherList.find((e) => e.id === id);
    navigate('/addvoucher', { state: { voucherId: findArrayData?.id } });
  };

  const resetAllFilter = async () => {
    setVoucherTypeName('');
    setEndDate('');
    setStartDate('');
    setSearchKey('');
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/VoucherMaster/allVoucher`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        console.log(response);
        setVoucherList(response.vou_masterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const handleApply = () => {
    setShowDateModel(true);
  };

  const handlePageClick = (data) => {
    getVoucherMasterData(data.selected + 1);
  };

  // =======================  VENDER & BRANCH =================

  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [selectedBranchId, setSelectedBranchId] = useState('');

  // Handle vendor selection change
  const selectVendorFilter = (e) => {
    let value = e.target.value;
    if (!value) {
      setSelectedVendorId(value);
      setSelectedBranchId('');
    } else {
      setSelectedVendorId(value);
      // getBranchMasterData(1, 10, "", value)
    }
  };

  // Handle branch selection change
  const selectbranchFilter = (e) => {
    setSelectedBranchId(e.target.value);
  };

  useEffect(() => {
    getVoucherMasterData(1, 10, '');
  }, [selectedVendorId, selectedBranchId]);

  return (
    <Col lg='12'>
      <Card className='bg-white pd-10 card-box mb-30'>
        {/* <CardTitle tag="h6" className="border-bottom p-3" >
                    <div className="d-flex align-items-center" style={{ marginBottom: 20 }}>
                        <i className="bi bi-card-text mr-2"></i>
                        Voucher Transactions
                    </div>

                    <Col>
                        <Row className="align-items-center">
                            <Col xl={2}>
                                <FormGroup>
                                    <Label for="voucherTypeList">Voucher Type:</Label>
                                    <Input 
                                        type="select"  className="custom-select"
                                        id="voucherTypeList"
                                        value={voucherTypeName}
                                        onChange={handleTypeNameChange}
                                    >
                                        <option value="">All</option>
                                        {voucherTypeList.map((option) => (
                                            <option key={option.vou_type_name} value={option.vou_type_name}>
                                                {option.vou_type_name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>

                            <Col xl={3}>
                                <FormGroup>
                                    <Label for="startDate">From:</Label>
                                    <Input 
                                        id="startDate"
                                        name="startDate"
                                        type="date"
                                        value={startDate}
                                        placeholder="Start Date"
                                        onChange={handleStartDateChange}
                                    />
                                </FormGroup>
                            </Col>

                            <Col xl={3}>
                                <FormGroup>
                                    <Label for="endDate">To:</Label>
                                    <Input 
                                        id="endDate"
                                        name="endDate"
                                        type="date"
                                        value={endDate}
                                        placeholder="End Date"
                                        onChange={handleEndDateChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xl={1} style={{ marginRight: 10 }}>
                                <Button color="primary" onClick={filterData}>
                                    Filter
                                </Button>
                            </Col>
                            <Col xl={1} style={{ marginRight: 10 }}>
                                <Button color="primary" onClick={resetAllFilter}>
                                    All
                                </Button>
                            </Col>
                            <Col xl={1}>
                                <Button color="primary ml-auto" onClick={onHandleAddVoucher}>
                                    Add
                                </Button>
                            </Col>

                        </Row>

                        <Row className="align-items-center" >
                            <Col xl={6}>
                                <FormGroup>
                                    <Label for="search">Search:</Label>
                                    <Input 
                                        id="search"
                                        name="search"
                                        placeholder="Search by VoucherNo / Type  / Cash-Bank Name"
                                        type="text"
                                        value={searchKey}
                                        onChange={onHandleSearchKeyItem}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>

                    {/* <div style={{}}>
                        <Row>
                            <Col xl={1} style={{}}>
                                <Button color="primary" onClick={filterData}>
                                    Filter
                                </Button>
                            </Col>
                            <Col xl={1}>
                                <Button color="primary ml-auto" onClick={onHandleAddVoucher}>
                                    Add Voucher
                                </Button>
                            </Col>
                        </Row>
                    </div> */}
        {/* </CardTitle> */}

        <CardTitle tag='h6' className='border-bottom p-3 mb-0 sticky-top'>
          <Row className='align-items-center g-2 mb-2'>
            <Col
              xs={12}
              className='d-flex justify-content-between align-items-center'
            >
              {/* Title aligned left */}
              <div className='d-flex align-items-center'>
                <i className='bi bi-card-text mr-2'></i>
                Voucher Transactions
              </div>

              <div className='d-flex justify-content-end mb-2'>
                <Button
                  color='success'
                  onClick={onHandleAddVoucher}
                  className='d-flex align-items-center'
                >
                  <i className='bi bi-plus-circle mr-2'></i>
                  New
                </Button>
              </div>
            </Col>
          </Row>

          <Row style={{ display: 'flex', justifyContent: 'start' }}>
            {/* Search and Filter in same line, centered */}
            <Col
              xl={12}
              md={6}
              className='d-flex justify-content-center justify-content-md-end align-items-center gap-2'
            >
              <Input
                id='search'
                name='search'
                placeholder='Search by VoucherNo / Type  / Cash-Bank Name'
                type='text'
                value={searchKey}
                onChange={onHandleSearchKeyItem}
              />
              <Button color='info' onClick={handleApply}>
                <i className='bi bi-funnel mr-1'></i>
                <p
                  style={{
                    fontSize: 8,
                    padding: 0,
                    margin: 0,
                    fontWeight: 'bold',
                  }}
                >
                  Filter
                </p>
              </Button>
            </Col>
          </Row>

          <Row
            style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}
          >
            {/* Vendor Filter */}
            {(vendorState?.vendors?.length === 0 ||
              vendorState?.vendors?.length > 1) && (
              <Col xl={3} md={4} sm={6} style={{ marginBottom: '15px' }}>
                <FormGroup>
                  <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                    Vendor
                  </label>
                  <Input
                    style={{
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '6px 12px',
                    }}
                    type='select'
                    className='custom-select'
                    name='selectedVendorId'
                    value={selectedVendorId}
                    onChange={selectVendorFilter}
                  >
                    <option value=''>-- Select Vendor --</option>
                    {vendorState?.vendors.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.vender_name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            )}

            {/* Branch Filter */}
            {(branchState?.branches?.length === 0 ||
              branchState?.branches?.length > 1) && (
              <Col xl={3} md={4} sm={6} style={{ marginBottom: '15px' }}>
                <FormGroup>
                  <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                    Branch
                  </label>
                  <Input
                    style={{
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '6px 12px',
                    }}
                    type='select'
                    className='custom-select'
                    name='selectedBranchId'
                    value={selectedBranchId}
                    disabled={!selectedVendorId}
                    onChange={selectbranchFilter}
                  >
                    <option value=''>-- Select Branch --</option>
                    {branchState?.branches
                      ?.filter(
                        (data) =>
                          selectedVendorId
                            ? String(data.vender_master_id) ===
                              String(selectedVendorId)
                            : true, // Show all branches if no vendor is selected
                      )
                      .map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.branch_name}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
            )}
          </Row>
        </CardTitle>

        <CardBody className=''>
          <Table hover striped responsive>
            <thead>
              <tr>
                {/*  <th>S. no.</th> */}
                <th>S. no.</th>
                {(user.user_profile == 'superadmin' || branchState.length) && (
                  <th>Branch/Vendor Name</th>
                )}
                <th>Date</th>
                <th>Voucher No</th>
                <th>Type</th>
                <th>Cash/Bank Name</th>
                <th>Amount</th>
                {/* <th>Action</th> */}
                {/* <th>Narration</th>
                                <th>Agst Bill(Camt)</th>
                                <th>Amount</th>
                                <th>Ins. Start Date</th>
                                <th>Ins. End Date</th> */}
              </tr>
            </thead>
            <tbody>
              {voucherList.map((transaction, index) => (
                <tr key={index}>
                  {/* <th scope="row">{index + 1}</th> */}

                  <th scope='row'>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        flexDirection: 'column',
                      }}
                    >
                      <span className='ms-2'>{index + 1}</span>
                      <Button
                        color='warning'
                        className='me-0 ms-2'
                        size='sm'
                        onClick={() => onHandleEditVoucher(transaction.id)}
                      >
                        <p
                          style={{
                            fontSize: 12,
                            padding: 0,
                            margin: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          <i className='bi bi-pencil mr-1'></i>Edit
                        </p>
                      </Button>
                    </div>
                  </th>
                  {(user.user_profile == 'superadmin' ||
                    branchState.length) && (
                    <td>
                      {transaction.branch_name} ***** <br></br>
                      {transaction.vender_name}
                    </td>
                  )}
                  <td>{transaction.vou_date?.split('T')[0]}</td>
                  <td>{transaction.vou_ref_no}</td>
                  <td>{transaction.vou_type}</td>
                  <td>{transaction.vou_cash_bank_name}</td>
                  <td>{transaction.tot_vou_amt}</td>
                  {/* <td>
                                        <Button color="success" size="bg" onClick={() => onHandleEditVoucher(transaction.id)}>
                                            Edit
                                        </Button>
                                    </td> */}
                  {/* <td>{transaction.vou_pname}</td> */}
                  {/* <td>{transaction.vou_narr}</td>
                                    <td>{transaction.vou_agst_bill}</td>
                                    {/* <td>{transaction.ins_start_date}</td> */}
                  {/* <td>{transaction.ins_end_date}</td> */}
                </tr>
              ))}
            </tbody>
          </Table>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={totalPage} // still 4000
            marginPagesDisplayed={1} // 1 page at start & end
            pageRangeDisplayed={2} // visible range around selected page
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
          />
        </CardBody>
      </Card>

      {/* Data Filter */}
      <CustomDateModal
        filterFlag='sale_report'
        showDateModel={showDateModel}
        setShowDateModel={setShowDateModel}
        allDateSelected={allDateSelected}
        setAllDateSelected={setAllDateSelected}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        // handleCloseModel={handleCloseModel}
        // handleFilterDate={handleFilterDate}
        getChallanData={getVoucherMasterData}
        voucherTypeOption={true}
        voucherTypeList={voucherTypeList}
        setVoucherTypeName={setVoucherTypeName}
        voucherTypeName={voucherTypeName}
      />
    </Col>
  );
};

export default Voucher;
